import { Component } from '@angular/core';

@Component({
  selector: 'ui-modal-header',
  templateUrl: './modal-header.component.html'
})
export class ModalHeaderComponent {
}